import type { CalculatorMeta } from '../../types/calculator';

const meta: CalculatorMeta = {
  route: '/fifty-thirty-twenty-calculator',
  component: () => import('../../routes/FiftyThirtyTwenty.svelte'),
  card: {
    id: 'fifty-thirty-twenty',
    title: '50/30/20 Budget Calculator',
    description: 'Calculate your monthly budget using the 50/30/20 rule — 50% needs, 30% wants, 20% savings.',
    icon: 'pie_chart',
    iconBgClass: 'bg-violet-50',
    iconTextClass: 'text-violet-600',
    href: '/fifty-thirty-twenty-calculator',
    category: 'Life & Budget',
  },
  seo: {
    title: '50/30/20 Budget Calculator – Free Budget Allocation Tool',
    description: 'Free 50/30/20 budget calculator. Enter your monthly income to see how to allocate 50% to needs, 30% to wants, and 20% to savings. The easiest way to budget your money.',
  },
};

export default meta;